import React from 'react';
import { pick } from 'lodash';
import { Space } from 'antd';
import { useRouter } from 'next/router';
import { useSignupVetterMutation } from '@vette/data-access';
import { phone as phoneUtils } from '@vette/common-utils';
import { AuthForm } from '../AuthForm';
import { User } from 'firebase/auth';
import { firebase, message } from '@vette/frontend-utils';
import { Title, Text } from '../../atoms';
import { FormValuesWithName } from '../AuthForm/types';

type Props = {
  redirectPath: string;
};

export const SignUp: React.FC<Props> = ({ redirectPath }) => {
  const router = useRouter();
  const { logout } = firebase.useFirebase();

  const [signupVetter] = useSignupVetterMutation();

  const onSuccess = async (user: User, values: FormValuesWithName) => {
    const { data } = await signupVetter({
      variables: {
        input: {
          ...pick(values, ['firstName', 'lastName']),
          firebaseUid: user.uid,
          phone: phoneUtils.normalize(values.phone),
          channel: values.otherChannel || values.channel,
        },
      },
    });

    if (!data) {
      message.error(
        "Something went wrong. Our team was notified and we're working on fixing the issue."
      );
      await logout();
      return;
    }

    if (data.signupVetter?.__typename === 'ValidationError') {
      message.error(data.signupVetter.messages[0]);
      await logout();
      return;
    }

    router.replace(redirectPath);
  };

  return (
    <AuthForm
      flow="signup"
      onSuccess={onSuccess}
      header={
        <Space direction="vertical" size={12}>
          <Title level={4}>Become a professional interviewer!</Title>
          <Text $size={15}>
            Join our exclusive network of Vetters today and start earning from
            right where you are.
          </Text>
        </Space>
      }
    />
  );
};
